import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "./reducers/reducer";
import { cesiumMiddleware } from "./middlewares/cesium-middleware";
import { arcgisMiddleware } from "./middlewares/arcgis-middleware";
import { MapSection } from "./reducers/map";
import { multiplePlotMiddleware } from "./middlewares/multiple-plot-middleware";
import { masterPlanMiddleware } from "./middlewares/master-plan-middleware";
import { masterStudyMiddleware } from "./middlewares/master-create-study-middleware";
import { masterUtilitiesMiddleware } from "./middlewares/master-utilities-middleware";

const cesium = cesiumMiddleware(MapSection.search);
const arcgis = arcgisMiddleware(MapSection.search);
const multiplePlotMap = multiplePlotMiddleware(MapSection.multiplePlot);
const masterPlanMap = masterPlanMiddleware(MapSection.masterPlan);
const masterCreateStudyMap = masterStudyMiddleware(MapSection.masterStudy);
const masterUtilitiesMap = masterUtilitiesMiddleware(MapSection.utilities);
const cesiumUtilitiesMap = cesiumMiddleware(MapSection.utilities);

export const setupStore = () => {
    return configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
      }).concat(cesium, arcgis, multiplePlotMap, masterPlanMap, masterCreateStudyMap, masterUtilitiesMap, cesiumUtilitiesMap)
    })
}

export type RootState = ReturnType<typeof reducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']